<template>
  <section>
    <div class="contain" v-if="isPC">
      <div
          class="topTitle"
          v-loading="loading"
          element-loading-text="loading..."
          element-loading-spinner="el-icon-loading"
          >
        <el-image
          :src="currentBanner"
          fit="fill"
          @load="loading = false"
          @error="loading = false"
          @click="bannerClick"
          >
          </el-image>
      </div>
      <div class="discountTabs f fw-w">
          <div class="discountTabs_item" v-for="item in OpenDiscount" :key="item.discountId" @click="discountClick(item)" :class="{active: activeDiscount.discountId === item.discountId}">
              <div class="discountTabs_item_font1 f-c">
                  <div class="discountNum">{{ item.discountRule === 1 ? `${item.discountPercent}%` : `USD ${item.discountFixed}` }}</div>
                  <div class="off">{{ $t('Index.Discount.OFF') }}</div>
              </div>
              <div class="discountTabs_item_font2">{{ item.discountDescription }}</div>
          </div>
      </div>
      <div class="imgList" v-loading="listLoading">
          <div class="filter f--c f-e" style="margin-bottom: 10px">
              <el-select v-model="listParams.countryCodeArray" :placeholder="$t('inSrock.shippingFrom')" @change="resetPage" clearable>
                  <el-option v-for="item in shippingFromList" :key="item.countryCode" :label="item.countryCn" :value="item.countryCode"></el-option>
              </el-select>
              <Sort @change="sortChange" style="margin-left: 15px;"></Sort>
          </div>
          <div class="f fw-w" v-if="productList.length">
            <div class="product" v-for="item in productList" :key="item.kkProductId">
              <Product :product="item" :productInfoVisible="true" kklocation="discountList" reportType="activity"></Product>
            </div>
          </div>
          <div v-if="!productList.length && !listLoading" class="empty">
            <div class="f-c-c fd-c">
              <img src="@/assets/img/activity_empty.svg" alt="">
              <p>{{ $t('Index.Discount.EventExpried') }}</p>
            </div>
          </div>
      </div>
      <el-button v-if="!userId" class="more f-c-c pointer" @click="jump('/login', 537)">
        <div>{{$t('indexPage.viewMore')}}</div>
        <i class="iconfont icon-jiantou-xuanze" />
      </el-button>
    </div>
    <div v-else class="mobileContain bg-white" v-loading="listLoading">
      <div class="topForm" id="topForm">
        <van-dropdown-menu>
          <van-dropdown-item v-model="mobileShipFrom" title="Ship From"  ref="shipFromSelectMobile">
            <van-cell center :title="item.countryCn" v-for="item in shippingFromList" :class="[item.checked?'checked-country':'']" :key="item.countryCn" @click="shipFromChangeMobile(item)">
              <template #right-icon>
                <i class="el-icon-check" v-if="item.checked"></i>
              </template>
            </van-cell>
          </van-dropdown-item>
          <van-dropdown-item :options="sortListForMobile" @change="value => sortChangeMobile(value)" v-model="sortKeyForMobile"></van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <div class="discountTabs f fw-w">
          <div class="discountTabs_item" v-for="item in OpenDiscount" :key="item.discountId" @click="discountClick(item)" :class="{active: activeDiscount.discountId === item.discountId}">
              <div class="discountTabs_item_percent f-c">
                  <div class="discountNum">{{ item.discountRule === 1 ? `${item.discountPercent}%` : `USD ${item.discountFixed}` }}</div>
              </div>
              <div class="discountTabs_item_off">{{ $t('Index.Discount.OFF') }}</div>
          </div>
      </div>
      <div class="f fw-w productList" v-if="productList.length">
        <div class="product" v-for="item in productList" :key="item.kkProductId">
          <Product :product="item" :productInfoVisible="true" kklocation="discountList" reportType="activity"></Product>
        </div>
      </div>
      <div v-if="!productList.length && !listLoading" class="empty">
        <div class="f-c-c fd-c">
          <img src="@/assets/img/activity_empty.svg" alt="">
          <p>{{ $t('Index.Discount.EventExpried') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import API from '@/api'
import getSortOptions from '@/config/sortOptions.js'
import Product from '@/components/Product.vue'
import Sort from '@/views/commodity/components/Sort.vue'
import DropdownMenu from 'vant/lib/dropdown-menu'
import 'vant/lib/dropdown-menu/style'
import DropdownItem from 'vant/lib/dropdown-item'
import 'vant/lib/dropdown-item/style'
import cell from 'vant/lib/cell'
import 'vant/lib/cell/style'

export default {
  components: {
    Product,
    Sort,
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem,
    'van-cell': cell
  },
  data() {
    return {
      discountTabs: [],
      activeDiscount: { discountId: '', type: 1 },
      listParams: {
        pageSize: 20,
        pageNumber: 1,
        sortName: this.sortName, // 需要排序的字段
        sortType: 2, // 排序方式：desc ,asc
        countryCodeArray: undefined // 发货国家编码
      },
      total: 0,
      shippingFromList: [],
      productList: [],
      loading: true,
      listLoading: false,
      sortKeyForMobile: 1,
      mobileShipFrom: undefined,
      currentBanner: undefined,
      bannerLink: ''
    }
  },
  computed: {
    OpenDiscount() {
      let arr = this.discountTabs.filter(e => e.status === 1 && e.type === 2)
      return arr
    },
    sortListForMobile() {
      const arr = getSortOptions.call(this)
      arr.forEach(e => {
        e.text = e.name
        e.value = e.key
      })
      return arr
    },
    userId() {
      return this.$store.state.common.userId
    }
  },
  created() {
    this.getShippingFromList()
    this.getDiscountListForTabs().then(() => {
      if (this.OpenDiscount.length) {
        // 无则默认第一个
        if (this.$route.query.discountId) {
          const { discountId, type } = this.$route.query
          this.activeDiscount = { discountId, type }
        } else {
          this.activeDiscount = this.OpenDiscount[0]
        }
        this.getDiscountConfig(this.activeDiscount.discountId)
        this.getProductList()
      }
    })
    window.addEventListener('scroll', this.scrollEvent)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    getShippingFromList() {
      API.getShippingFromList({
        pageSize: 100,
        pageNumber: 1
      }).then(result => {
        // 以国家编码去重 且中国南中国北合并
        const map = {}
        result.data.list.forEach(item => {
          if (['CN_N', 'CN_S'].includes(item.countryCode)) {
            map['CN'] = {
              countryCn: 'China',
              countryCode: 'CN'
            }
            return
          }
          map[item.countryCode] = {
            countryCn: item.countryCn,
            countryCode: item.countryCode
          }
        })
        this.shippingFromList = Object.values(map)
      })
    },
    sortChange(sortName, sortType) {
      const sortMap = {
        desc: 1,
        asc: 2
      }
      this.listParams.sortName = sortName
      this.listParams.sortType = sortType // sortMap[sortType]
      this.resetPage()
    },
    sortChangeMobile(value) {
      const { sortName, sortType } = this.sortListForMobile.find(e => e.value === value)
      this.sortChange(sortName, sortType)
    },
    resetPage() {
      this.listParams.pageNumber = 1
      this.productList = []
      this.getProductList()
    },
    scrollEvent() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + windowHeight >= scrollHeight) {
        if (this.total > this.productList.length && !this.listLoading && this.userId) {
          this.getProductList()
        }
      }
    },
    getParams() {
      const { discountId, type } = this.activeDiscount
      const params = Object.assign({}, this.listParams, { discountId, type })
      // const params = Object.assign({}, this.listParams, { discountId, type, countryCodeArray: this.getCountryCodeArray() })
      if (params.countryCodeArray) params.countryCodeArray = [params.countryCodeArray]
      else params.countryCodeArray = undefined
      return params
    },
    async getProductList() {
      try {
        this.listLoading = true
        const params = this.getParams()
        let res = await API.discountDetailProduct(params)
        this.productList = [...this.productList, ...res.data.list]
        this.listParams.pageNumber++
        this.total = res.data.total
        this.listLoading = false
      } catch (error) {
        this.$message.error(error.data)
        this.listLoading = false
      }
    },
    getDiscountListForTabs() {
      return new Promise((resolve, reject) => {
        API.getDiscountListForTabs({
          pageNumber: 1,
          pageSize: 100,
          sortType: 3
        }).then(res => {
          this.discountTabs = res.data.list
          resolve()
        }).catch(err => {
          this.$message.error(err.data)
          reject()
        })
      })
    },
    discountClick(item) {
      if (this.activeDiscount.discountId === item.discountId) return
      this.activeDiscount = item
      this.getDiscountConfig(this.activeDiscount.discountId)
      this.resetPage()
    },
    shipFromChangeMobile(value) {
      this.$set(value, 'checked', !value.checked)
      this.resetPage()
    },
    getCountryCodeArray() {
      let countryCodeArray = this.shippingFromList.filter(e => e.checked).map(e => e.countryCode)
      return countryCodeArray
    },
    jump(path, event_id) {
      this.$router.push(path)
    },
    getDiscountConfig(discountId) {
      API.getDiscountConfig({ discountId }).then(res => {
        this.currentBanner = res.data.bannerImgurl
        this.bannerLink = res.data.bannerLink
      })
    },
    bannerClick() {
      if (this.bannerLink) window.open(this.bannerLink)
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
    width: 1400px;
    margin: 0 auto;
    .topTitle {
        width: 100%;
        margin: 20px 0;
        background-color: #F5F7F7;
        min-height: 200px;
        /deep/.el-image {
          border-radius: 16px 12px;
        }
    }
    .discountTabs {
        font-size: 20px;
        font-weight: bold;
        .discountTabs_item {
            width: 420px;
            background-color: #fff;
            text-align: center;
            padding: 20px 0;
            border: 2px solid transparent;
            border-radius: 10px;
            box-sizing: border-box;
            margin: 10px 70px 10px 0;
            .discountTabs_item_font1 {
              align-items: flex-end;
              margin-bottom: 8px;
              .discountNum {
                font-size: 40px;
                height: 40px;
              }
              .off {
                  padding: 4px 8px;
                  background-color: #333;
                  color: #fff;
                  margin-left: 8px;
                  font-size: 18px;
                  height: 30px;
              }
            }
            .discountTabs_item_font2 {
                font-weight: 500;
            }
        }
        .discountTabs_item:nth-of-type(3n) {
            margin-right: 0;
        }
        .active {
            border-color: #99C41C;
            color: #99C41C;
            .off {
              background-color: #99C41C !important;
            }
        }
        .discountTabs_item:hover {
            border-color: #99C41C;
        }
    }
    .imgList {
      padding-bottom: 50px;
        .product {
          width: 260px;
          margin-right: 25px;
        }
        .product:nth-of-type(5n) {
            margin-right: 0px;
        }
      .empty {
        padding: 20px;
        p {
          margin-top: 20px;
        }
      }
    }
}
.mobileContain {
  .topForm {
    display: flex;
    position: fixed;
    top: .86rem;
    left: 0;
    right: 0;
    z-index: 10;
    /deep/.van-dropdown-menu {
      flex: 2;
    }
    /deep/.van-dropdown-menu__bar {
      box-shadow: none;
    }
  }
  .discountTabs {
        font-size: 20px;
        font-weight: bold;
        padding: 60px 0 .3rem 0;
        .discountTabs_item {
            width: 33.33%;
            background-color: #fff;
            text-align: center;
            border: 1px solid transparent;
            box-sizing: border-box;
            padding: .2rem .3rem;
            .discountTabs_item_percent {
              font-size: .4rem;
            }
            .discountTabs_item_off {
              font-size: .3rem;
            }
        }
        .active {
            border-color: #333;
            color: #fff;
            background-color: #333;
        }
    }
    .productList {
      padding: .2rem;
      >.product {
        width: 50%;
        padding: .1rem;
      }
    }
  .empty {
    padding: 20px;
    img {
      width: 60%;
    }
    p {
      margin-top: 20px;
    }
  }
}
.more {
  display: block;
  margin: 0 auto;
  margin-bottom: 30px;
  /deep/ span{
    display: flex;
  }
}
/deep/.van-dropdown-item__option--active {
    color: #99C41C;
  background: rgba(153, 196, 28, 0.04);
}
/deep/.van-dropdown-item__icon{
  color: #99C41C;
}

/deep/.van-dropdown-menu__title--active {
   color: #99C41C;
}
/deep/.van-cell .van-cell--center{
  color: #99C41C;
}
/deep/.el-icon-check{
  color: #99C41C;
}
.checked-country{
  color: #99C41C;
   background: rgba(153, 196, 28, 0.04);
}
</style>
